export  class ActivityArea{
    id:number;
    activity_area_name:string;
}